import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { ICurrentWorkspaceStore } from '../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { UserDropdown } from '../components/UserDropdown';
import { IAnnotationCreationService } from '../modules/annotation/annotationCreation.service';
import { useAuthService } from '../modules/auth/auth.service';
import { IImagesUploaderService } from '../modules/datasets/imagesUpload.service';
import { IUserStore } from '../modules/user/user.store';

export const UserDropdownContainer = observer((): ReactElement => {
  const authService = useAuthService();
  const userStore = useInjection(IUserStore.$);
  const imagesUploaderService = useInjection(IImagesUploaderService.$);
  const annotationCreationService = useInjection(IAnnotationCreationService.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const [showModal, setShowModal] = useState(false);

  const handleLogout = async (): Promise<void> => {
    if (imagesUploaderService.datasetsQueue.length !== 0) {
      setShowModal(true);
      return;
    }
    await annotationCreationService.unlockImagesAsync();
    authService.logout();
  };

  const handleConfirm = async (): Promise<void> => {
    imagesUploaderService.cancelUploads();
    authService.logout();
    return Promise.resolve();
  };

  const handleCancel = (): void => {
    setShowModal(false);
  };

  return (
    <UserDropdown
      workspaceId={currentWorkspaceStore.currentWorkspace.id}
      shortName={userStore.shortName}
      showModal={showModal}
      onLogout={handleLogout}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
    />
  );
});
